import React, { useState, useEffect, useRef } from 'react';

// --- ICONS ---
const Icons = {
  Edit: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>,
  Trash: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>,
  Check: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>,
  X: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>,
  Plus: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>,
  ChevronRight: () => <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>,
  ArrowLeft: () => <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>,
  Building: () => <svg className="w-6 h-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
};

// --- MOCK DATA: ALL AVAILABLE USERS FOR SUGGESTIONS ---
const ALL_USERS_DB = [
  { id: 101, name: 'Vipul Gobarbhai Hadiya', image: 'https://i.pravatar.cc/150?u=1' },
  { id: 102, name: 'Pravin Kantibhai Malaviya', image: 'https://i.pravatar.cc/150?u=2' },
  { id: 103, name: 'Mukesh Vasantray Solanki', image: 'https://i.pravatar.cc/150?u=3' },
  { id: 104, name: 'Anil Valjibhai Vaghona', image: 'https://i.pravatar.cc/150?u=4' },
  { id: 105, name: 'Rahul Sharma', image: 'https://i.pravatar.cc/150?u=8' },
  { id: 106, name: 'Amit Patel', image: 'https://i.pravatar.cc/150?u=9' },
  { id: 107, name: 'Sanket Shah', image: 'https://i.pravatar.cc/150?u=10' },
];

const ManageCommittee = () => {
  // --- STATE ---
  const [selectedChapter, setSelectedChapter] = useState(null);
  
  // Stores the committee members. Structure: { 'President': [userObj], 'Vice President': [] }
  const [committeeData, setCommitteeData] = useState({});
  
  // State for Add/Edit logic
  const [editingMemberId, setEditingMemberId] = useState(null); // ID of member being edited
  const [addingToType, setAddingToType] = useState(null); // 'Committee Type' string where we are adding a user
  
  // Search/Autocomplete State
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  
  const searchWrapperRef = useRef(null);

  // Fixed Committee Types
  const ALL_COMMITTEE_TYPES = [
    'President', 'Vice President', 'Secretory & Treasurer', 'SOP Committee',
    'Agenda Committee', 'Welcome Committee', 'Chapter Growth', 'VUF Activity',
    'Web Portal', 'Social Media', 'Mentor Co-Ordi.', 'Power Team', 'LVH',
    'Elevator Speech', 'Referral Value', 'Specific Ask', 'Face-2-Face',
    'Social Activity', 'Mobile Application'
  ];

  // City Data
  const cityData = [
    { id: 1, cityName: 'Ahmedabad', chapters: [{ id: 'ahd1', name: 'Yadunandan' }] },
    { id: 2, cityName: 'Surat', chapters: [{ id: 'srt1', name: 'Krishna' }] },
  ];

  // --- INITIAL LOAD (Mock Data) ---
  useEffect(() => {
    // Initial dummy data for demonstration
    setCommitteeData({
      'President': [{ id: 101, name: 'Vipul Gobarbhai Hadiya', image: 'https://i.pravatar.cc/150?u=1' }],
      'SOP Committee': [
        { id: 104, name: 'Anil Valjibhai Vaghona', image: 'https://i.pravatar.cc/150?u=4' },
      ]
    });
  }, []);

  // Close suggestions on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchWrapperRef.current && !searchWrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // --- HANDLERS ---

  // 1. Search Logic
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (query.length > 0) {
      const filtered = ALL_USERS_DB.filter(user => 
        user.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredUsers(filtered);
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };

  // 2. Select User from Suggestions
  const selectUser = (user) => {
    if (editingMemberId) {
      // Logic for SAVING EDIT
      const updatedData = { ...committeeData };
      for (const type in updatedData) {
        updatedData[type] = updatedData[type].map(m => 
          m.id === editingMemberId ? user : m // Replace old user with new selected user
        );
      }
      setCommitteeData(updatedData);
      setEditingMemberId(null);
    } else if (addingToType) {
      // Logic for ADDING NEW
      const updatedData = { ...committeeData };
      if (!updatedData[addingToType]) updatedData[addingToType] = [];
      
      // Prevent duplicates
      if (!updatedData[addingToType].find(u => u.id === user.id)) {
          updatedData[addingToType].push(user);
      }
      setCommitteeData(updatedData);
      setAddingToType(null);
    }
    setSearchQuery('');
    setShowSuggestions(false);
  };

  // 3. Start Editing
  const startEdit = (member) => {
    setEditingMemberId(member.id);
    setAddingToType(null); // Ensure add mode is off
    setSearchQuery(member.name); // Pre-fill input
    setFilteredUsers(ALL_USERS_DB); // Show all initially
  };

  // 4. Start Adding
  const startAdd = (type) => {
    setAddingToType(type);
    setEditingMemberId(null); // Ensure edit mode is off
    setSearchQuery('');
    setFilteredUsers([]);
  };

  // 5. Delete Member
  const handleDelete = (type, memberId) => {
    if(window.confirm("Are you sure you want to remove this member?")) {
        const updatedData = { ...committeeData };
        updatedData[type] = updatedData[type].filter(m => m.id !== memberId);
        setCommitteeData(updatedData);
    }
  };

  const cancelAction = () => {
    setEditingMemberId(null);
    setAddingToType(null);
    setSearchQuery('');
    setShowSuggestions(false);
  };

  // --- RENDER HELPERS ---

  // The Search Input Component (Used for both Add and Edit)
  const UserSearchDropdown = () => (
    <div className="relative w-full max-w-xs" ref={searchWrapperRef}>
      <input
        type="text"
        autoFocus
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder="Type to search user..."
        className="w-full border border-blue-400 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100"
      />
      {showSuggestions && (
        <div className="absolute z-50 left-0 right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
          {filteredUsers.length > 0 ? (
            filteredUsers.map(user => (
              <div 
                key={user.id} 
                onClick={() => selectUser(user)}
                className="flex items-center px-3 py-2 hover:bg-blue-50 cursor-pointer"
              >
                <img src={user.image} alt="" className="w-8 h-8 rounded-full mr-3 object-cover" />
                <span className="text-sm text-gray-700">{user.name}</span>
              </div>
            ))
          ) : (
            <div className="px-3 py-2 text-sm text-gray-500">No users found</div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <div>
      
      {!selectedChapter ? (
         /* --- VIEW 1: SELECT CITY (Same as before) --- */
         <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {cityData.map((city) => (
              <div key={city.id} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow">
                <div className="bg-blue-50/50 p-4 border-b border-gray-100 flex items-center gap-3">
                  <div className="p-2 bg-white rounded-lg shadow-sm"><Icons.Building /></div>
                  <h3 className="text-lg font-bold text-gray-800">{city.cityName}</h3>
                </div>
                <div className="divide-y divide-gray-100">
                  {city.chapters.map((chapter) => (
                    <button
                      key={chapter.id}
                      onClick={() => setSelectedChapter(chapter)}
                      className="w-full text-left p-4 hover:bg-gray-50 transition-colors flex items-center justify-between group"
                    >
                      <span className="font-medium text-gray-700 group-hover:text-blue-600">{chapter.name}</span>
                      <Icons.ChevronRight />
                    </button>
                  ))}
                </div>
              </div>
            ))}
         </div>
      ) : (
        /* --- VIEW 2: MANAGE MEMBERS (Add/Edit/Delete Page) --- */
        <div className="animate-fade-in-up">
            <button 
                onClick={() => setSelectedChapter(null)}
                className="mb-4 flex items-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
            >
                <Icons.ArrowLeft /> Back to Cities
            </button>

            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <div className="p-4 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
                    <h2 className="text-lg font-bold text-gray-800">Manage Committee: {selectedChapter.name}</h2>
                    <span className="text-xs text-gray-500 bg-white px-2 py-1 rounded border">Admin Mode</span>
                </div>

                <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="border-b border-gray-200 bg-gray-50/30">
                            <th className="p-4 py-3 font-semibold text-gray-700 w-1/4 border-r border-gray-100">Committee Type</th>
                            <th className="p-4 py-3 font-semibold text-gray-700">Members</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                    {ALL_COMMITTEE_TYPES.map((type, index) => {
                        const members = committeeData[type] || [];
                        const isAddingThisType = addingToType === type;

                        return (
                            <tr key={index}>
                                <td className="p-4 text-sm font-medium text-gray-800 align-top border-r border-gray-100 bg-gray-50/10">
                                    {type}
                                </td>
                                <td className="p-4 align-top">
                                    <div className="flex flex-col gap-3">
                                        
                                        {/* 1. LIST EXISTING MEMBERS */}
                                        {members.map((member) => (
                                            <div key={member.id} className="flex items-center justify-between group bg-white p-2 rounded-lg border border-transparent hover:border-gray-200 hover:shadow-sm transition-all">
                                                
                                                {/* CONDITIONAL: EDIT MODE vs DISPLAY MODE */}
                                                {editingMemberId === member.id ? (
                                                    // INLINE EDIT MODE
                                                    <div className="flex items-center w-full gap-2 animate-pulse-once">
                                                        <UserSearchDropdown />
                                                        <button onClick={cancelAction} className="text-red-500 hover:bg-red-50 p-1 rounded"><Icons.X /></button>
                                                    </div>
                                                ) : (
                                                    // DISPLAY MODE
                                                    <>
                                                        <div className="flex items-center gap-3">
                                                            <img src={member.image} alt="" className="w-8 h-8 rounded-full object-cover border border-gray-200" />
                                                            <span className="text-sm font-medium text-gray-700">{member.name}</span>
                                                        </div>
                                                        <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                                            <button 
                                                                onClick={() => startEdit(member)} 
                                                                className="p-1.5 text-blue-500 hover:bg-blue-50 rounded"
                                                                title="Edit"
                                                            >
                                                                <Icons.Edit />
                                                            </button>
                                                            <button 
                                                                onClick={() => handleDelete(type, member.id)} 
                                                                className="p-1.5 text-red-500 hover:bg-red-50 rounded"
                                                                title="Delete"
                                                            >
                                                                <Icons.Trash />
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        ))}

                                        {/* 2. ADD NEW MEMBER AREA */}
                                        {isAddingThisType ? (
                                            // INLINE ADD MODE
                                            <div className="flex items-center gap-2 mt-2 p-2 bg-blue-50/50 rounded-lg border border-blue-100">
                                                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-400">?</div>
                                                <UserSearchDropdown />
                                                <button onClick={cancelAction} className="text-gray-500 hover:bg-gray-200 p-1 rounded"><Icons.X /></button>
                                            </div>
                                        ) : (
                                            // ADD BUTTON
                                            <button 
                                                onClick={() => startAdd(type)}
                                                className="flex items-center gap-2 text-xs font-semibold text-blue-600 hover:bg-blue-50 px-3 py-2 rounded-md w-fit mt-1 transition-colors border border-dashed border-blue-200 hover:border-blue-400"
                                            >
                                                <Icons.Plus /> Add Member
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
                </div>
            </div>
        </div>
      )}
    </div>
  );
};

export default ManageCommittee;